<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import EditPage from './pages/editPage.vue'
export default {
  name: 'App',
  components: {
    // EditPage
  }
}
</script>
<style>
#mms3D{
  width: 100%;
  height: 100%;
}
</style>